import type { AppBuildInfo } from '@nexops/shared';

/** Build, który działa w tej karcie (stałe wstrzyknięte przez scripts/build-info.mjs). */
export const APP_BUILD: AppBuildInfo = {
  app: 'web',
  version: __APP_VERSION__,
  sha: __BUILD_SHA__,
  builtAt: __BUILD_TIME__,
};

/** Skrócona forma do stopki: `v0.9.0`; z identyfikatorem builda w dymku. */
export const appVersionLabel = () => `v${APP_BUILD.version}`;
export const appBuildTitle = () => `${APP_BUILD.version} · ${APP_BUILD.sha} · ${APP_BUILD.builtAt}`;
